import { endAndMoreOptions } from '@/pages/mission/info/card/event/customBranch/SelectBranch';

import { NodeEnums } from '../const/node';

/**
 * 模版节点
 */
export const templateNode = {
  [NodeEnums.story]: {
    id: '1',
    data: {
      leftHandle: false,
      rightHandle: true,
      propsInfo: { // 道具卡信息
        list: [],
      },
      info: { isDraft: true },
    },
    position: { x: 250, y: 25 },
    type: NodeEnums.story,
    width: 350,
    height: 145,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.chapter]: {
    id: '1',
    data: {
      leftHandle: false,
      rightHandle: true,
      info: { isDraft: true },
    },
    position: { x: 250, y: 25 },
    type: NodeEnums.chapter,
    width: 180,
    height: 46,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.propsMission]: {
    id: 'props',
    data: {
      leftHandle: false,
      rightHandle: true,
      propsInfo: { // 道具卡信息
        list: [{}],
      },
    },
    position: { x: 250, y: 25 },
    type: NodeEnums.story,
    width: 350,
    height: 145,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.scene]: {
    id: '2',
    data: {},
    position: { x: 100, y: 125 },
    draggable: false,
    type: NodeEnums.scene,
    width: 308,
    height: 145,
    deletable: false,
  },
  [NodeEnums.gamePlay]: {
    id: 'gamePlay',
    data: {},
    position: { x: 100, y: 125 },
    type: NodeEnums.gamePlay,
    width: 240,
    height: 154,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.startMission]: {
    id: 'startMission',
    data: { hiddenId: '2' },
    position: { x: 250, y: 250 },
    type: NodeEnums.startMission,
    width: 126,
    height: 46,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.mainMission]: {
    id: 'mainMission',
    data: { info: { list: [] }, hiddenId: '2' },
    position: { x: 250, y: 250 },
    type: NodeEnums.mainMission,
    width: 721,
    height: 255,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.addCondition]: {
    id: 'addCondition',
    data: { info: { isEmpty: true }, hiddenId: '2' },
    position: { x: 250, y: 250 },
    type: NodeEnums.addCondition,
    width: 40,
    height: 40,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.passCondition]: {
    id: 'passCondition',
    data: { hiddenId: '2' },
    position: { x: 250, y: 250 },
    type: NodeEnums.passCondition,
    width: 200,
    height: 130,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.trapCondition]: {
    id: 'trapCondition',
    data: { hiddenId: '2' },
    position: { x: 250, y: 250 },
    type: NodeEnums.trapCondition,
    width: 200,
    height: 130,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.successMission]: {
    id: 'successMission',
    data: { hiddenId: '2' },
    position: { x: 250, y: 250 },
    type: NodeEnums.successMission,
    width: 40,
    height: 40,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.failMission]: {
    id: 'failMission',
    data: { hiddenId: '2' },
    position: { x: 250, y: 250 },
    type: NodeEnums.failMission,
    width: 40,
    height: 40,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.endMission]: {
    id: 'endMission',
    data: { hiddenId: '2' },
    position: { x: 250, y: 250 },
    type: NodeEnums.endMission,
    width: 126,
    height: 46,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.jump]: {
    id: 'jump',
    data: { hiddenId: '2', rightHandle: false },
    position: { x: 250, y: 250 },
    type: NodeEnums.jump,
    width: 154,
    height: 44,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.collapse]: {
    id: 'collapse',
    data: { hiddenId: '2' },
    position: { x: 250, y: 250 },
    type: NodeEnums.collapse,
    width: 36,
    height: 36,
    draggable: false,
    delete: false,
    deletable: false,
  },
  // storyLine
  [NodeEnums.storyLineScene]: {
    id: 'storyLineScene',
    data: {
      leftHandle: false,
      rightHandle: false,
    },
    position: { x: 250, y: 25 },
    type: NodeEnums.storyLineScene,
    width: 141,
    height: 40,
    draggable: false,
    deletable: false,
  },
  [NodeEnums.storyLineCondition]: {
    id: 'storyLineCondition',
    data: {
      leftHandle: false,
      rightHandle: false,
    },
    position: { x: 250, y: 25 },
    type: NodeEnums.storyLineCondition,
    width: 145,
    height: 32,
    draggable: false,
    deletable: false,
  },
};

// 普通AI幕
export const templateGroupNode = [
  templateNode[NodeEnums.collapse],
  templateNode[NodeEnums.mainMission],
  templateNode[NodeEnums.addCondition],
];

// 结局幕
export const templateEndGroupNode = [
  {
    ...templateNode[NodeEnums.jump],
    data: {
      info: {
        nextScene: { id: '', name: endAndMoreOptions[0].label },
      },
    },
  },
];

// 固定选项幕
export const templateOptionGroupNode = [
  templateNode[NodeEnums.collapse],
  templateNode[NodeEnums.addCondition],
];

// 默认模板
export const defaultTemplateNode = [
  templateNode[NodeEnums.chapter],
  { ...templateNode[NodeEnums.scene], data: { info: { isDraft: true } } },
  // ...templateGroupNode,
];

